import React from 'react';
import { css } from 'aphrodite';
import styles from './success-message-styles';
import {FaCheck} from 'react-icons/fa';

const SuccessMessageView = (props) => (
  <div className={css(styles.root, props.showSuccess && styles.visibleRoot)}>
    <div className={css(styles.content)}>
      <FaCheck className={css(styles.check)} />
      <div className={css(styles.successMessageText)}>{props.successMessage}</div>
    </div>
  </div>
);

export default SuccessMessageView;



// WEBPACK FOOTER //
// ./src/components/snackbars/success-message-view.js